import React from "react";
export default ({ className, color = null }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <mask id="path-1-inside-1" fill="white">
      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" />
    </mask>
    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white" />
    <path
      d="M14 8V10H16V8H14ZM8 8V6H6V8H8ZM8 14V16H10V14H8ZM6 14H4V16H6V14ZM6 8H8V6H6V8ZM0 8H-2V10H0V8ZM0 6V4H-2V6H0ZM6 6V8H8V6H6ZM6 0V-2H4V0H6ZM8 0H10V-2H8V0ZM8 6H6V8H8V6ZM14 6H16V4H14V6ZM14 6H8V10H14V6ZM6 8V14H10V8H6ZM8 12H6V16H8V12ZM8 14V8H4V14H8ZM6 6H0V10H6V6ZM2 8V6H-2V8H2ZM0 8H6V4H0V8ZM8 6V0H4V6H8ZM6 2H8V-2H6V2ZM6 0V6H10V0H6ZM8 8H14V4H8V8ZM12 6V8H16V6H12Z"
      fill={color ? color : "white"}
      mask="url(#path-1-inside-1)"
    />
  </svg>
);
